import BaseView from "./_BaseView.js";
import Table from "../components/Table";
import Confirm from "../components/Confirm";
import Api from "../Api";

export default class AppTypeView extends BaseView {
    constructor() {
        super();
        this.formSelector = '#appTypeForm';
        this.formUrl = '/api/apptypes';
        this.formTpl = 'app-type-form';
        this.formTitle = Lang.apptype;
        this.defaultObject = {
            title: '',
        };
        this.formCallback = function () {
            this.table.reload();
        };
    }

    getFormData() {
        const data = $(this.formSelector).aeroSerialize();
        data.isEnterprise = !!data.isEnterprise;
        return data;
    }

    init() {
        super.init();

        if ($('#app-types').length > 0) {
            this.table = new Table('app-types', '/api/apptypes/table', [
                {data: 'title', orderable: true},
                {data: 'count'},
                {data: 'tools', orderable: false},
            ]);
        }
    }

    setEvents() {
        super.setEvents();
        const self = this;
        const section = $('#app-types');

        //Add
        section.parents('main').find('.add-app-type').on("click", function () {
            self.renderForm();
            return false;
        });

        //Delete
        section.on("click", ".delete", function () {
            const id = $(this).parents('div:eq(0)').data('id');
            const name = $(this).parents('tr').find('td:eq(0)').text();

            Confirm({
                ok: Lang.delete,
                title: name,
                msg: `${Lang.delsure}<br><br><strong class="msg-box danger">${Lang.willdeletesegment}</strong>`,
                onConfirm: function () {
                    Api.send(`/api/apptypes/${id}`, {}, 'delete').done(function () {
                        self.table.reload();
                    });
                }
            });

            return false;
        });

        //Edit
        section.on("click", ".edit", function () {
            const id = $(this).parents('div:eq(0)').data('id');

            Api.send(`/api/apptypes/${id}`).done(function (r) {
                self.renderForm(r);
            });
            return false;
        });
    }
}
